import { REMOVE_SHIPMENT } from "../Actions/types";

const initialState = {
  loading: false,
  totals: 0,
  shipment: [],
};

export default function (state = initialState, action) {
  switch (action.type) {
    case "LOADING_SHIPMENT":
      return {
        ...state,
        loading: true,
      };
    case "GET_SHIPMENTS":
      return {
        ...state,
        shipment: action.payload.data,
        totals: action.payload.totals,
        loading: false,
      };
    case REMOVE_SHIPMENT:
      return removeShipment(state, action.payload);
    default:
      return state;
  }
}

const removeShipment = (state, action) => {
  return {
    ...state,
    shipment: action.shipment ? state.shipment.map((item) => item.id == action.id ? { ...item, ...action.shipment } : item) : state.shipment.filter((item) => item.id !== action.id),
  };
};
